import { faAlignLeft, faAlignRight } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { useEffect, useState } from "react"


function ResponseAdditionText({actionAddition, responseAddition, updateAdditions}) {
  const [left, setLeft] = useState(false)
  const [body, setBody] = useState(responseAddition?.body || '')
    useEffect(() => {
      updateAdditions({
        qid:actionAddition._id,
        qtext:actionAddition.text,
        qorder:actionAddition.order,
        qrequired:actionAddition.required,
        qlanguage:actionAddition.language,
        qhighlight: actionAddition.highlight,
        body:body
      })
    }, [body])
    
 
    const validBodyClass = (!body && actionAddition.required) ? "form__input--incomplete" : ''
    const alignTextClass = left ? "form__input--ltr" : ''
  return (
    <>
       <div className="form__row">
                <label className="form__label" htmlFor={`body-${actionAddition._id}`}>
                {actionAddition.text}</label>   <button
                            className="icon-button icon-button-small"
                            title="Save"
                            onClick={()=>{setLeft(!left)}}
                        >
                            {(left)? <FontAwesomeIcon icon={faAlignRight} /> : <FontAwesomeIcon icon={faAlignLeft} /> } 
                        </button>
                        </div>
                 <textarea
                    className={`form__input  form__input--body ${validBodyClass} ${alignTextClass} `}
                    id={`body-${actionAddition._id}`}
                    name={`body-${actionAddition._id}`}
                    value={body}
                    onChange={(e)=>setBody(e.target.value)}
                />  
    </>
   
  )
}

export default ResponseAdditionText